import { type UploadDestination } from "./uploadCoordinator";

export interface CollectedUploadFile {
  readonly file: File;
  readonly relativePath: string;
  readonly directoryPath: string;
}

export const normalizeUploadFilename = (filename: string): string => filename.trim();

export const getUploadFilename = (file: Pick<CollectedUploadFile, "relativePath">): string =>
  normalizeUploadFilename(file.relativePath.split("/").at(-1) ?? "");

export interface UploadDialogState {
  readonly destination: UploadDestination;
  readonly initialFiles?: readonly CollectedUploadFile[];
  readonly collectionMessage?: string;
}
